module.exports = __webpack_public_path__ + "img/22_27.ce3e4d8a.png";